<template>
  <div class="page-classification pb-5 pt-3">
    <div class="row">
      <div class="col-lg-12 gy-3 text-center">
        <h1 class="hGen">{{$t("step3")}}</h1>
      </div>
      <metadata-navigation-com></metadata-navigation-com>
    </div>
    <div class="row mt-3">
      <div class="col-lg-8" >
          <classification-data-com/>
      </div>
      <div class="col-lg-4">
          <file-selection-com/>       
      </div>
      
    </div>

  </div>
</template>

<script>
import MetadataNavigationCom from '../../components/MetadataNavigationCom.vue';
import FileSelectionCom from '../../components/filerelated/FileSelectionCom.vue'
import ClassificationDataCom from '../../components/classification/ClassificationDataCom.vue'

export default {
    name: "ClassificationView",
    components: {
        MetadataNavigationCom,
        ClassificationDataCom,
        FileSelectionCom,
    },
    computed: {
  }

}
</script>
